import {IdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TombOfNefertitiMainGameIdleAnimationView} from "./TombOfNefertitiMainGameIdleAnimationView";

export class TombOfNefertitiMainGameIdleAnimationController extends IdleAnimationController {
    protected _betWinsData: IBetWinData[] | null;
    private _view: TombOfNefertitiMainGameIdleAnimationView;

    constructor() {
        super({
            startTime: 5,
            minInterval: 5,
            maxInterval: 10
        });

        this._view = new TombOfNefertitiMainGameIdleAnimationView();
    }

    protected onGameDataParsed(data: ParsedGameData): void {
        this._betWinsData = data.betWins;
    }

    protected hasWin(): boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected playIdleAnimation(): void {
        this._view.playAnimation();
    }
}
